import Vue from 'vue';

import App from './App.vue';
import { createI18n } from './plugins/i18n';
import vuetify from './plugins/vuetify';
import './plugins/threedim';

export async function createApp(): Promise<Vue> {
  const i18n = await createI18n();
  return new Vue({
    vuetify,
    i18n,
    el: '#app',
    render: (h) => h(App),
  });
}
